module.exports = __webpack_public_path__ + "img/litloyal-demo4.2172175d.png";